import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AddFamilyMemberComponent } from '@modal/add-family-member/add-family-member.component';
import { ConfirmationBoxComponent } from '@modal/confirmation-box/confirmation-box.component';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { Globals } from 'src/app/globals';
import { RegUser } from '../basic-reg/RegUser';

@Component({
  selector: 'app-family-member',
  standalone: true,
  templateUrl: './family-member.component.html',
  styleUrls: ['./family-member.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    MatTooltipModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class FamilyMemberComponent implements OnInit {

  members: RegUser[] = [];
  errorMessage: string = '';

  currentUser = new RegUser();
  requestPath = this.global.requestPath;
  private skipFirstDidEnter: boolean = true;

  constructor(public modalCtrl: ModalController
    , private global: Globals
    , private authService: AuthServiceService
    , private formBuilder: FormBuilder
    , private loader: LoaderService
    , private cdr: ChangeDetectorRef
    , private router: Router) {
  }

  ngOnInit() {
    this.loadPageData();
  }

  ionViewDidEnter() {
    if (this.skipFirstDidEnter) {
      this.skipFirstDidEnter = false;
      return;
    }
    this.loadPageData();
  }

  loadPageData = () => {
    this.currentUser = this.authService.getLoggedInUser();
    if (!this.global.isEmpty(this.currentUser)) {
      this.currentUser.imageUrl = this.authService.getProfilePicture() as string;
    }
    this.fetchUser();
    this.getMembers();
  }

  fetchUser = () => {
    this.currentUser = this.authService.getLoggedInUser();
  }

  async addMember() {
    const modal = await this.modalCtrl.create({
      component: AddFamilyMemberComponent,
      componentProps: {
        "type": 1,
        "memberId" : 0
      }
    });

    modal.onDidDismiss().then(responseData => {
      if (!this.global.isEmpty(responseData)) {
        var resData = responseData.data;
        if (!this.global.isEmpty(resData)) {
          this.getMembers();
        }
      }
    });

    return await modal.present();
  }

  async deleteMember(id: any) {
    const modal = await this.modalCtrl.create({
      component: ConfirmationBoxComponent,
      componentProps: {
        "title": "Confirmation",
        "message": "Are you sure to delete this member?"
      }
    });

    modal.onDidDismiss().then(responseData => {
      if (!this.global.isEmpty(responseData)) {
        var resData = responseData.data;
        if (!this.global.isEmpty(resData)) {
          this.deleteMemberById(id);
        }
      }
    });

    return await modal.present();
  }

  async editMember(id: any) {
    const modal = await this.modalCtrl.create({
      component: AddFamilyMemberComponent,
      componentProps: {
        "type": 2,
        "memberId" : id
      }
    });

    modal.onDidDismiss().then(responseData => {
      if (!this.global.isEmpty(responseData)) {
        var resData = responseData.data;
        if (!this.global.isEmpty(resData)) {
          this.getMembers();
        }
      }
    });

    return await modal.present();
  }

  deleteMemberById(id: any) {
    // Delete Member
    this.loader.show("Please wait....");
    this.authService.postEncrypt('user?' + this.requestPath + '=deleteUserMemberById&memberId=' + id, null)
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);

        if ((res as any).success) {
          this.getMembers();
        } else {
          this.errorMessage = (res as any).message;
        }
      }, error => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Error occured at server";
      });
  }

  getMembers = () => {
    this.errorMessage = "";
    this.members = [];
    this.loader.show("Loading data...");
    this.authService.get('user?' + this.requestPath + '=getUserMember')
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if ((res as any).success) {
          const decryptedData = this.global.decrypt((res as any).data);
          const memberList = Array.isArray(decryptedData)
            ? decryptedData
            : (Array.isArray((decryptedData as any)?.data) ? (decryptedData as any).data : []);

          this.members = memberList.map((emp: any) => {
            const lastName = emp.lastName == null ? "" : emp.lastName;
            return {
              ...emp,
              lastName: lastName,
              name: (emp.firstName || "") + " " + lastName
            };
          });

          this.cdr.detectChanges();
        } else {
          this.errorMessage = (res as any).message;
        }
      }, (error: any) => {
        this.loader.hide();
        // console.log("error in getting employees");
        this.errorMessage = "Error occured while fetching the employees.";
      })
  }

}
